import React from 'react';
import { getUserFullName } from '../../../utils';
import { MentionTag } from './mention-tag';

interface User {
  userID: string;
  firstName: string;
  lastName: string;
}

interface MentionRendererProps {
  mentionText: string;
  users: User[];
  currentUser?: User;
  index: number;
}

/**
 * Finds a user based on mention text
 */
const findUserByMention = (mentionText: string, users: User[]): User | undefined => {
  if (mentionText.startsWith('@ORG_ID_')) {
    return users.find((user) => `@${user.userID}` === mentionText);
  }

  if (mentionText.startsWith('@')) {
    return users.find((user) => `@${getUserFullName(user.firstName, user.lastName)}`.trim() === mentionText);
  }

  return undefined;
};

/**
 * Renders a mention tag or fallback text
 */
export const MentionRenderer: React.FC<MentionRendererProps> = ({ mentionText, users, currentUser, index }) => {
  const user = findUserByMention(mentionText, users);

  if (!user) {
    return <React.Fragment key={`mention-fallback-${mentionText}-${index}`}>{mentionText}</React.Fragment>;
  }

  const isSelf = user.userID === currentUser?.userID;

  return (
    <MentionTag
      key={`mention-${mentionText}-${index}`}
      label={`@${getUserFullName(user.firstName, user.lastName)}`}
      isSelf={isSelf}
    />
  );
};
